module.exports = __webpack_public_path__ + "static/media/gaming8.d11b8249.webp";